import { render, staticRenderFns } from "./other.vue?vue&type=template&id=523334e1"
import script from "./other.vue?vue&type=script&lang=js"
export * from "./other.vue?vue&type=script&lang=js"
import style0 from "./other.vue?vue&type=style&index=0&id=523334e1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports